import React, {Component} from 'react';
import classNames from 'classnames';

class Textarea extends Component {
  handleChange = e => {
    const {onChange = () => {}, onValueChange = () => {}} = this.props;
    onChange(e);
    onValueChange(e);
  };

  className() {
    return classNames(
      this.props.className,
      {_error: this.props.error},
      'ds-input',
    );
  }

  handleChange(e) {
    this.props.onChange(e);
  }

  renderError() {
    if (this.props.error) return <i> {this.props.error} </i>;
  }

  render() {
    return (
      <label className={this.className()}>
        <span>{this.props.label}</span>
        {this.renderError()}
        <textarea
          name={this.props.name}
          placeholder={this.props.placeholder}
          value={this.props.value}
          id={this.props.id}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          data-testid={`${this.props.name}-text-area`}
          onClick={this.props.onClick}
        />
        <small>{this.props.tip}</small>
      </label>
    );
  }
}

Textarea.defaultProps = {
  name: 'input',
  placeholder: 'Input value',
  refName: 'input',
  label: '',
  tip: '',
  disabled: false,
  onClick: () => {},
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/Textarea.js